import request from '../request'

export default {
  getMedios() {
    return request.get('medio')
  },

  getTiposMedio() {
    return request.get('medio_tipo')
  },

  getBases() {
    return request.get('base')
  },

  getZonasMedio() {
    return request.get('medio_zona')
  },

  addMedio(data) {
    return request.post('medio', data)
  },
  updateMedio(data) {
    return request.put(`medio/${data.ID_MEDIO}`, data)
  },
  deleteMedio(data) {
    return request.delete(`medio/${data.ID_MEDIO}`)
  },
  getIdDispositivo(idMedio) {
    return request.get(`medio/${idMedio}`)
  },

  getEmergencias() {
    return request.get('emergencia_medio')
  },
  setEmergenciaMedio(data) {
    return request.post('emergencia_medio', data)
  },

  getTrackMedio(idMedio, timeBack) {
    return request.get(`medio_posicion/${idMedio}/${timeBack}`)
  },

  getTrackFechasMedio(idDispositivo, dateInit, dateEnd) {
    return request.get(`medio_posicion/${idDispositivo}/${dateInit}/${dateEnd}`)
  },
  getTrackFechasInPolygon(data) {
    return request.post('medios_posicion_polygon/', data)
  },

  getComunidadesAutonomas() {
    return request.get('comunidades_autonomas')
  },

  getServicios() {
    return request.get('servicios')
  },

  getDispositivosHermes() {
    return request.get('dispositivosHermes')
  },

  getHorasJornadaDia({ fecha, idIncendio }) {
    return request.get('medio/horas_jornada', { params: { fecha, idIncendio } })
  },

  getTiemposLlegadaDia({ fecha, idIncendio }) {
    return request.get('medio/tiempos_llegada', { params: { fecha, idIncendio } })
  }
}
